import { FETCH_STATS, STATS_LOADING } from '../actions/stats';

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_STATS:
      return {
        ...state,
        stats: action.payload,
      };
    case STATS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      return state;
  }
}
